import React from 'react';
const painPoints = [{
  emoji: '😰',
  text: 'Tu scooter hace ruidos que no sabés identificar'
}, {
  emoji: '⚡',
  text: 'Problemas eléctricos sin saber por dónde empezar'
}, {
  emoji: '⏰',
  text: 'Horas perdidas viendo tutoriales que no resuelven nada'
}, {
  emoji: '😓',
  text: 'Inseguridad ante fallas mecánicas o de plegado'
}, {
  emoji: '💸',
  text: 'Gastás fortunas en talleres por arreglos simples'
}, {
  emoji: '📄',
  text: 'No sabés qué herramientas necesitás realmente'
}, {
  emoji: '🔥',
  text: 'Frustración por no poder hacer mantenimiento básico'
}, {
  emoji: '💼',
  text: 'Querés monetizar tu conocimiento pero no sabés cómo'
}];
export function PainPoints() {
  return <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 bg-zinc-900/30 border-y border-zinc-800/50" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-3 md:mb-6" data-id="element-73">
          Esto es para vos si...
        </h2>
        <p className="text-base md:text-xl text-zinc-400 text-center mb-8 md:mb-12" data-id="element-74">
          ¿Te sentís identificado con alguna de estas situaciones?
        </p>

        <div className="grid sm:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-75">
          {painPoints.map((point, i) => <div key={i} className="bg-zinc-950 p-3 md:p-5 rounded-xl border border-zinc-800 flex items-start gap-3 md:gap-4" data-id="element-76">
              <span className="text-2xl md:text-3xl shrink-0" data-id="element-77">
                {point.emoji}
              </span>
              <span className="text-sm md:text-lg text-zinc-300" data-id="element-78">
                {point.text}
              </span>
            </div>)}
        </div>

        <div className="bg-[#00b8ff]/10 border-l-4 border-[#00b8ff] p-4 md:p-6 rounded-r-xl" data-id="element-79">
          <p className="text-base md:text-xl text-white font-semibold" data-id="element-80">
            ✅ Si te identificás con al menos una, el Mega Kit Scooter fue
            diseñado para vos.
          </p>
        </div>
      </div>
    </section>;
}